<template>
  <div class="table-item">
    <el-row>
      <el-col :span="12">
        <div class="bm-bar">
          <Bm4000Bar
            :min-particle="minParticle"
            :op="{
              title: {
                text: translateTo('气溶胶多通道粒子数模板', 'device', { num: 4 }),
                textStyle: { fontSize: 14 }
              },
              grid: { top: 55 },
              yAxis: { name: translateTo('粒子数(个秒)', 'device'), nameGap: 10 },
              xAxis: { name: translateTo('粒径(μm)', 'device') },
              series: [
                {
                  data: [
                    source.bio2Paror1,
                    source.bio2Paror2,
                    source.bio2Paror3,
                    source.bio2Paror4,
                    source.bio2Paror5,
                    source.bio2Paror6,
                    source.bio2Paror7,
                    source.bio2Paror8,
                    source.bio2Paror9,
                    source.bio2Paror10,
                    source.bio2Paror11,
                    source.bio2Paror12,
                    source.bio2Paror13
                  ]
                }
              ]
            }"
          />
        </div>
      </el-col>
      <el-col :span="12">
        <div class="bm-bar">
          <Bm4000Bar
            :min-particle="minParticle"
            :op="{
              title: {
                text: translateTo('荧光多通道粒子数模板', 'device', { num: 4 }),
                textStyle: { fontSize: 14 }
              },
              grid: { top: 55 },
              yAxis: { name: translateTo('粒子数(个秒)', 'device'), nameGap: 10 },
              xAxis: { name: translateTo('粒径(μm)', 'device') },
              series: [
                {
                  data: [
                    source.bio2Bioor1,
                    source.bio2Bioor2,
                    source.bio2Bioor3,
                    source.bio2Bioor4,
                    source.bio2Bioor5,
                    source.bio2Bioor6,
                    source.bio2Bioor7,
                    source.bio2Bioor8,
                    source.bio2Bioor9,
                    source.bio2Bioor10,
                    source.bio2Bioor11,
                    source.bio2Bioor12,
                    source.bio2Bioor13
                  ]
                }
              ]
            }"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Bm4000Bar from '@/views/realdata/BM4000/components/bm4000-bar';

export default {
  components: {
    Bm4000Bar
  },
  sockets: {
    '/socket/basic'(res) {
      if (this.sn !== res.sn) return;
      this.minParticle = res.dynamicInfoMap.minParticle || '0.5';
    }
  },
  props: {
    source: {
      type: Object,
      default: () => ({})
    },
    sn: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      minParticle: '0.5'
    };
  }
};
</script>
